import type { PILOT_DETAILS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-details-card/pilot-details-card.fr.ts";

export const PILOT_DETAILS_CARD_ENGLISH_LOCALE = {
  title: "Pilot details",
  location: "Location",
  serialNumber: "Serial number",
  siteId: "Site Id",
  hardwareId: "Hardware Id",
  csId: "Cs Id",
  softwareVersion: "Sofrware version",
  operator: "Operator",
} satisfies typeof PILOT_DETAILS_CARD_FRENCH_LOCALE;
